/* tslint:disable */
/* eslint-disable */
export enum SettingCategory {
  Global = 'GLOBAL',
  Contract = 'CONTRACT',
  Customer = 'CUSTOMER',
  System = 'SYSTEM'
}
